<div class="feature-tile" [ngClass]="toneClass">
	<p class="feature-tile__label">{{ label }}</p>
	<p class="feature-tile__value">{{ value }}</p>
	<p class="feature-tile__sub" *ngIf="sub">{{ sub }}</p>
</div>
